import gql from 'graphql-tag'

export const CHECK_RESET_FAMILY_MEMBER_PASSWORD_TOKEN_MUTATION = gql`
  mutation CheckResetFamilyMemberPasswordToken ($token: String!, $code: String!){
    checkResetFamilyMemberPasswordToken(
      data: {
        token: $token
        code: $code
      }
    )
  }
`
